import serviceRequest from "utils/request";

const baseUrl = "/api/file";

export const uploadEXPERTFile = (param, config = {}) => {
	return serviceRequest({
		url: `${baseUrl}/import/expert/upload`,
		method: "post",
		data: param,
		...config,
	});
};

export const downLoadEXPERTFile = (param) => {
	return serviceRequest({
		url: `${baseUrl}/import/expert/download`,
		method: "post",
		data: param,
		responseType: "blob",
	});
};
